// extracted by mini-css-extract-plugin
export default {"socialmediabutton":"socialmedia_socialmediabutton__YLTg3"};